import React from 'react';
import PropTypes from 'prop-types';

/**
 * AdminLoader
 * Petit indicateur de chargement fixé en haut-centre de l'écran, non bloquant.
 * - Utilisation: <AdminLoader show={loading} message="Chargement..." />
 * - Accessibilité: aria-live polite pour annoncer les changements sans interrompre l'utilisateur.
 */
const AdminLoader = ({ show, message = 'Chargement…', className = '' }) => {
  if (!show) return null;
  return (
    <div
      className={`fixed top-6 left-1/2 -translate-x-1/2 z-50 pointer-events-none ${className}`}
      aria-live="polite"
      role="status"
    >
      <div className="pointer-events-auto flex items-center gap-3 px-4 py-2.5 rounded-xl shadow-2xl bg-white/95 backdrop-blur border border-[#e88c00]/40 ring-1 ring-[#e88c00]/20">
        <svg
          className="h-6 w-6 animate-spin text-[#e88c00]"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
        </svg>
        <span className="text-sm font-semibold text-gray-900">{message}</span>
      </div>
    </div>
  );
};

AdminLoader.propTypes = {
  // Affiche ou non le loader
  show: PropTypes.bool,
  // Message de statut à afficher
  message: PropTypes.string,
  // Classes additionnelles optionnelles
  className: PropTypes.string,
};

export default AdminLoader;
